export enum StatusColor {
    gray = 'rgb(50, 56, 66)',
    azure = 'rgb(36, 107, 229)',
    red = 'rgb(242, 33, 40)',
    brown = 'rgb(148, 62, 0)',
    orange = 'rgb(239, 152, 52)',
    purple = 'rgb(131, 83, 226)',
    blue = 'rgba(74, 82, 187)',
    green = 'rgb(17, 123, 52)',
    black = 'rgb(40, 40, 40)',
}

export const caseStatusOptions = [
    { label: 'Assessment', color: StatusColor.brown, value: 'ASSESSMENT' },
    { label: 'Not Assigned', color: StatusColor.gray, value: 'NOT_ASSIGNED' },
    { label: 'Client with Issues', color: StatusColor.red, value: 'CLIENT_WITH_ISSUES' },
    { label: 'Processing', color: StatusColor.blue, value: 'PROCESSING' },
    { label: 'In Review', color: StatusColor.orange, value: 'IN_REVIEW' },
    { label: 'Ready for Submission', color: StatusColor.purple, value: 'READY_FOR_SUBMISSION' },
    { label: 'Awaiting ITA', color: StatusColor.purple, value: 'AWAITING_ITA' },
    { label: 'Submitted', color: StatusColor.green, value: 'SUBMITTED' },
    { label: 'Visa Results', color: StatusColor.green, value: 'VISA_RESULTS' },
    { label: 'Awaiting LOA', color: StatusColor.orange, value: 'AWAITING_LOA' },
    { label: 'Closed', color: StatusColor.black, value: 'CLOSED' },
    { label: 'On Hold', color: StatusColor.azure, value: 'ON_HOLD' },
    { label: 'Removed', color: StatusColor.red, value: 'REMOVED' },
];

export const getCaseStatusColor = (status: string): string =>
    caseStatusOptions.find((option) => option.value === status)?.color ?? StatusColor.gray;
